// general
import Antispam from '../../components/Antispam'
import CookieBubble from '../../components/CookieBubble'

// project
import Accord from './Accord'
import BackgroundNumber from './BackgroundNumber'
import Decorations from './Decorations'
import Explode from './Explode'
import Gallery from './Gallery'
import Graphs from './Graphs'
import Progress from './Progress'
import MenuOpener from './MenuOpener'
import More from './More'
import Nav from './Nav'
import Horizontal from './Horizontal'
import SocialPopup from './SocialPopup'
import Sticky from './Sticky'

const Components = {
    Accord,
    Antispam,
    BackgroundNumber,
    Decorations,
    Explode,
    CookieBubble,
    Gallery,
    Graphs,
    Progress,
    MenuOpener,
    More,
    Nav,
    Horizontal,
    SocialPopup,
    Sticky
}

export default Components


// WEBPACK FOOTER //
// ./components/index.js